module.exports = __webpack_public_path__ + "static/media/corp_cf_2.f935d411.png";